// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import prepareNestedString from 'helpers/prepareNestedString'

// gets nested value of a validation object.
// o is the validation object and
// s is the string that points to the desired value.
// example:
// o = {
//   foo: [{
//     bar: {
//       fa: 'Test',
//     },
//   }],
// }
// s = foo[0]bar.fa
// getNestedByString (o, s) ==> 'Test'
const getNestedByString = (o, s) => {
  s = prepareNestedString(s)
  for (let i = 0, n = s.length; i < n; ++i) {
    let k = s[i]
    if (k in o) {
      o = o[k]
    } else {
      return
    }
  }
  return o
}

export default getNestedByString
